// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","dropdown":"styles_dropdown__LANgz","apply":"styles_apply__iBcVU","actions":"styles_actions__Caqc5"};